import React, { Component } from 'react';
import { Col, Row } from 'antd'
import './styles.css'

class MapStep extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listStep: props.listStep || [
                { index: 1, title: 'Select Mapping and Choose File' },
                { index: 2, title: 'Validate and Import' },
                { index: 3, title: 'Complete' }
            ]
        }
    }

    renderStep = () => {
        const { stepCurrentActual } = this.props;
        const { listStep } = this.state

        return listStep.map((e, i) => {
            return (
                <div
                    className={
                        'present-step '
                        + (listStep.length === (i + 1) && 'represent-step-last-import-order')
                        + ((stepCurrentActual === "1" && e.index === 1) ? " import-order-bg-step1 " : "")
                        + ((stepCurrentActual === "2" && e.index === 2) ? " import-order-bg-step2 " : "")
                        + ((stepCurrentActual === "3" && e.index === 3) ? " import-order-bg-step3 " : "")
                    }
                    key={i}
                >
                    <div className='item'>
                        <div className={'number-step '
                            + ((stepCurrentActual === "1" && e.index === 1) ? " import-order-scale-step1 " : "")
                            + ((stepCurrentActual === "2" && e.index === 2) ? " import-order-scale-step2 " : "")
                            + ((stepCurrentActual === "3" && e.index === 3) ? " import-order-scale-step3 " : "")
                            + ((stepCurrentActual === "1" && e.index === 1) ? " import-order-point-step1 " : "")
                            + ((stepCurrentActual === "2" && (e.index === 2 || e.index === 1)) ? " import-order-point-step2 " : "")
                            + ((stepCurrentActual === "3" && (e.index === 3 || e.index === 1 || e.index === 2)) ? " import-order-point-step3 " : "")
                        }>{e.index}</div>
                        {listStep.length !== (i + 1) && (
                            <div className={'distance-step ' +
                                ((stepCurrentActual === '2' && e.index === 1) || (stepCurrentActual === '3' && e.index === 1) ? 'distance-step1-full' : '') +
                                ((stepCurrentActual === '3' && e.index === 2) ? 'distance-step2-full distance-step1-full' : '')
                            }></div>
                        )}
                    </div>
                    <div className={'title-step'
                        + ((stepCurrentActual === "1" && e.index === 1) ? " import-order-bold-step1 " : "")
                        + ((stepCurrentActual === "2" && e.index === 2) ? " import-order-bold-step2 " : "")
                        + ((stepCurrentActual === "3" && e.index === 3) ? " import-order-bold-step3 " : "")
                    }
                    >{e.title}</div>
                </div>
            )
        })
    }

    render() {
        return (
            <div id='map-step-import-order'>
                {this.renderStep()}
            </div>
        );
    }
}

export default MapStep;



// WEBPACK FOOTER //
// ./src/components/step-import-order/components/map-step/index.js